/**
 * Base URL for the Little Sky API.
 *
 * Resolution order:
 *   1. `VITE_API_URL`, when set — the deploy-time override.
 *   2. `'/api'` in dev, which `vite.config.ts` proxies to the API and rewrites
 *      away the prefix (see `server.proxy`). A relative path is what keeps dev
 *      requests same-origin.
 *   3. The deployed API origin in a production build.
 *
 * Case 3 is the one worth stating out loud. The storefront is served as static
 * files by Cloudflare Pages, which has no `'/api'` proxy — a request to
 * `'/api/...'` hits Pages' SPA fallback and comes back as `index.html` with
 * **HTTP 200**. Every API call then silently receives HTML instead of JSON, and
 * because the status is 200 nothing looks wrong until you parse the body.
 *
 * `VITE_API_URL` lives in `.env.production`, which is gitignored, so a CI build
 * never sees it. Previously that meant a CI-deployed storefront was broken; the
 * production fallback below is what makes the build correct without it.
 */
const PRODUCTION_API_ORIGIN = 'https://littlesky-api.shelfhand.com'

export const API_BASE =
  import.meta.env.VITE_API_URL || (import.meta.env.DEV ? '/api' : PRODUCTION_API_ORIGIN)
